import { Component } from '@angular/core';
import { ProductClassificationService } from '../services/product-classification.service';
import { ConfigurationService } from '../services/configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { ProductClass } from '../enums/productClass.enum';
import { Injectable } from '@angular/core';
import { StartupService } from '../services/startup.service';

@Injectable({
  providedIn: 'root',
})

@Component({
  selector: 'app-product-classification-panel',
  templateUrl: './product-classification-panel.component.html',
  styleUrl: './product-classification-panel.component.scss'
})
export class ProductClassificationPanelComponent {
  active: boolean = true;
  productClass: ProductClass = ProductClass.STANDARD;
  deliveryTimeInWeeks: number = 2;
  isSharedLink: boolean = false;

  constructor(
    private ProductClassificationService: ProductClassificationService,
    private ConfigurationService: ConfigurationService,
    private TranslateService: TranslateService,
    private StartupService: StartupService
    ) {
      ConfigurationService.productClassChanged$.subscribe(() => this.CheckProductClass());
      ProductClassificationService.classificationReceived$.subscribe(() => this.CheckProductClass());
      StartupService.sharedLinkConfiguration$.subscribe((data: false | string) => {
        if (data === false) {
          this.isSharedLink = false;
          return;
        }
        this.isSharedLink = true;
      });
    }
  
  CheckProductClass() {
    this.productClass = this.ProductClassificationService.GetCellProductClass(this.ConfigurationService.configuration);
    this.deliveryTimeInWeeks = this.ProductClassificationService.GetDeliveryTimeInWeeks(this.productClass);
  }

}
